import React, { PureComponent } from 'react';

import Tooltip from './tooltip';

const CustomFieldItem = ({ id, name, description, color, icon, selected, onClick }) => {
    const handleClick = () => {
        onClick && onClick(id);
    }

    return (
        <div className={'custom-field-selector-item' + (selected ? ' selected' : '')} onClick={handleClick}>
            <Tooltip tooltip={name}>
                <div className="item-inner">
                    <div className="item-icon" style={{ color }}>{ icon }</div>
                </div>
            </Tooltip>
        </div>
    );
}

export default class CustomFieldSelector extends PureComponent {
    render() {
        return (
            <div className="custom-field-selector">

                {
                    this.props.options.map(field => <CustomFieldItem
                        key={field.id}
                        id={field.id}
                        name={field.name}
                        description={field.description}
                        color={field.color}
                        icon={field.icon}
                        selected={field.id === this.props.selected}
                        onClick={this.props.onSelect}
                    />)
                }
            </div>
        );
    }
}
